module.exports = __webpack_public_path__ + "static/media/pg_tablet_highlight.b2771368.svg";